import * as React from "react";

import Grid from "@mui/material/Grid";

import Box from "@mui/material/Box";
import { SubjectCard } from "../../components/Subject-section/SubjectCard";
import { Typography } from "@mui/material";

import { useDispatch, useSelector } from "react-redux";
import { getPhyLesson } from "../../apiCalls/userApiCalls";

import Header from "../../components/HomeComponents/Header/Header";
import { Loader } from "../../components/loaderComponent/Loding";

const PaymentStatusEnum = {
  PENDING: "pending",
  APPROVED: "approved",
  REJECTED: "rejected",
};

export const PhysicsSection = () => {
  const dispatch = useDispatch();
  let allow = {
    allow: false,
    msg: "Sign In as a Student To Access This Page",
  };
  const user = JSON.parse(sessionStorage.getItem("user"));

  const payment = JSON.parse(sessionStorage.getItem("payment"));
  const thisMonth = new Date().getMonth();
  const thisDay = new Date().getDay();

  const checkPayment = (payment) => {
    if (payment?.status === PaymentStatusEnum.REJECTED) {
      return false;
    }
    if (payment?.month !== thisMonth) {
      if (payment?.month === thisMonth - 1) {
        if (thisDay > 15) {
          return false;
        }
        return true;
      } else return false;
    } else {
      if (payment?.status === PaymentStatusEnum.APPROVED) {
        return true;
      } else if (payment?.status === PaymentStatusEnum.PENDING) {
        if (thisDay > 15) {
          return false;
        }
        return true;
      } else {
        return false;
      }
    }
  };

  if (user) {
    if (user?.role !== "Student") {
      allow.allow = false;
      allow.msg = "Sign in as a student to access this page";
    } else if (user.classType === "chemistry") {
      allow.allow = false;
      allow.msg = "You are not enrolled in Physics class";
    } else if (!checkPayment(payment)) {
      allow.allow = false;
      allow.msg =
        "You have not paid for this month or your payment is rejected";
    } else if (user.classType === "physics" || user.classType === "both") {
      allow.allow = true;
      allow.msg = "";
    }
    //TODO :check the paid or not
  }

  console.log(allow);
  React.useEffect(() => {
    getPhyLesson(dispatch);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const lessons = useSelector((state) => state.lesson.lessons);
  const isFetching = useSelector((state) => state.lesson.isFetching);

  return (
    <React.Fragment>
      {/* <CommonHeader />
      <Box sx={{ width: "100%", height: "80px" }}></Box> */}
      <Header />
      {isFetching ? (
        <Loader />
      ) : (
        <Box
          sx={{
            width: "100%",

            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            backgroundRepeat: "repeat",
            backgroundImage: `url(${"https://firebasestorage.googleapis.com/v0/b/s2a-e8459.appspot.com/o/assets%2Fbackground.png?alt=media&token=a9467179-4448-456a-9892-de49d2eef4b7"})`,
            objectPosition: "center",
            backgroundPosition: "center",
          }}
        >
          <Typography
            variant="h3"
            sx={{ fontWeight: 700, fontFamily: "Anton, sans-serif" }}
          >
            Physics
          </Typography>
          <Grid
            sx={{
              marginTop: "20px",
            }}
            container
            p={5}
            rowSpacing={1}
            columnSpacing={{ xs: 1, sm: 2, md: 3 }}
          >
            {lessons.length > 0 ? (
              lessons.map((subject, index) => {
                return (
                  <Grid key={index} item xs={12} sm={6} md={3}>
                    <SubjectCard subject={subject} allow={allow} />
                  </Grid>
                );
              })
            ) : (
              <Grid
                container
                item
                xs={12}
                sm={12}
                md={12}
                justifyContent={"center"}
              >
                <Typography
                  variant="h5"
                  sx={{ fontWeight: 400, marginTop: "100px" }}
                >
                  No Lessons
                </Typography>
              </Grid>
            )}
          </Grid>
        </Box>
      )}
    </React.Fragment>
  );
};
